import React from 'react'
import DashboardTable from '../dashboardtable/dashboardtable';
import data from './data.json'
import search from '../../../../assets/images/search.png'
import add from '../../../../assets/images/add.png'

function Broker() {
    return (
        <>
            <div className='driver-head'>
                <h3 className='dashboard-head-title'>Brokers</h3>
                <div>
                    <div className='input-header-admin'>
                        <input
                            type="text"
                            placeholder='Search' />
                        <img src={search} alt="" />
                    </div>
                    <div className='nav-buttons'>
                        <button style={{ background: '#FF7B00', marginRight: '15px' }}><img src={add} alt="" />  Add Driver</button>
                    </div>
                </div>
            </div>
            <div className='dashboard-table-wrapper_'>
                <DashboardTable size={10} columns={columns} rows={data.data} height={"510px"} />
            </div>
        </>
    )
}

const columns = [
    { field: 'name', headerName: 'Name', minWidth: 190 },
    { field: 'phone', headerName: 'Phone No.', minWidth: 190 },
    { field: 'email', headerName: 'Email', minWidth: 250 },
    { field: 'address', headerName: 'Address', minWidth: 250 }
];

export default Broker